import { ISystemSettingsDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';

export default class SystemSettingsRepository extends ESSRepository {
  private static readonly baseRoute = '/systemsettings';
  private static readonly apiURL = SystemSettingsRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<{ data: ISystemSettingsDTO; apiVersion: string }> => {
    try {
      const { data, headers } = await http.get(SystemSettingsRepository.apiURL);
      return {
        data,
        apiVersion: headers['api-version'],
      };
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
